import { useState } from "react";

const PRESET_COLORS = [
  "#6366f1","#8b5cf6","#ec4899","#ef4444","#f97316",
  "#eab308","#22c55e","#14b8a6","#3b82f6","#06b6d4",
];

const STATUS_OPTS = [
  ["PLANNING", "Planning"],
  ["ACTIVE", "Active"],
  ["ON_HOLD", "On Hold"],
  ["COMPLETED", "Completed"],
  ["ARCHIVED", "Archived"],
];

export default function EpicFormModal({ epic, onSave, onClose }) {
  const isEdit = !!epic;
  const [form, setForm] = useState({
    name:        epic?.name        || "",
    description: epic?.description || "",
    status:      epic?.status      || "PLANNING",
    color:       epic?.color       || PRESET_COLORS[0],
    icon:        epic?.icon        || "🧩",
    targetDate:  epic?.targetDate  || "",
  });
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.name.trim()) return;
    onSave({
      ...form,
      targetDate: form.targetDate || null,
    });
  };

  return (
    <div className="proj-modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="proj-modal">
        <div className="proj-modal-header">
          <h3>{isEdit ? "Edit Epic" : "New Epic"}</h3>
          <button className="proj-modal-close" onClick={onClose}>✕</button>
        </div>
        <form className="proj-modal-body" onSubmit={handleSubmit}>
          <div className="proj-form-row proj-color-row">
            <div className="proj-form-group" style={{ flex: 1 }}>
              <label>Icon</label>
              <input className="proj-input proj-icon-input" value={form.icon}
                     onChange={e => set("icon", e.target.value)} placeholder="🧩" maxLength={4} />
            </div>
            <div className="proj-form-group" style={{ flex: 3 }}>
              <label>Color</label>
              <div className="proj-color-swatches">
                {PRESET_COLORS.map(c => (
                  <button key={c} type="button"
                          className={`proj-color-swatch ${form.color === c ? "active" : ""}`}
                          style={{ background: c }}
                          onClick={() => set("color", c)} />
                ))}
                <input type="color" className="proj-color-custom" value={form.color}
                       onChange={e => set("color", e.target.value)} title="Custom color" />
              </div>
            </div>
          </div>

          <div className="proj-form-group">
            <label>Name *</label>
            <input className="proj-input" required autoFocus value={form.name}
                   onChange={e => set("name", e.target.value)} placeholder="e.g. Onboarding Revamp" />
          </div>

          <div className="proj-form-group">
            <label>Description</label>
            <textarea className="proj-textarea" rows={3} value={form.description}
                      onChange={e => set("description", e.target.value)}
                      placeholder="What does this epic cover?" />
          </div>

          <div className="proj-form-row">
            <div className="proj-form-group" style={{ flex: 1 }}>
              <label>Status</label>
              <select className="proj-select" value={form.status} onChange={e => set("status", e.target.value)}>
                {STATUS_OPTS.map(([k, label]) => <option key={k} value={k}>{label}</option>)}
              </select>
            </div>
            <div className="proj-form-group" style={{ flex: 1 }}>
              <label>Target Date</label>
              <input type="date" className="proj-input" value={form.targetDate || ""}
                     onChange={e => set("targetDate", e.target.value)} />
            </div>
          </div>

          <div className="proj-modal-footer">
            <button type="button" className="proj-btn-secondary" onClick={onClose}>Cancel</button>
            <button type="submit" className="proj-btn-primary">{isEdit ? "Save Changes" : "Create Epic"}</button>
          </div>
        </form>
      </div>
    </div>
  );
}
